import { computed, Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ModalService {
  private readonly _openCount = signal(0);

  readonly isAnyOpen = computed(() => this._openCount() > 0);

  register(): void {
    this._openCount.update((count) => count + 1);
  }

  unregister(): void {
    this._openCount.update((count) => Math.max(0, count - 1));
  }
}
